// extracted by mini-css-extract-plugin
export default {"edit":"Client_edit__4LH6a","editNew":"Client_editNew__1zyii","bookingLabel":"Client_bookingLabel__RgZhE","placeholderMatch":"Client_placeholderMatch__WyAxS"};